import { AfterViewInit, ChangeDetectionStrategy, Component } from "@angular/core";
import { AgEditorComponent } from "@bfx/ag-grid-angular";
import { FwdRollBaseEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollBaseEditor";
import {
  AMOUNT_VALUE_ACCESSOR,
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
} from "shared/base-components/number-spinner.component";

@Component({
  selector: "fwd-roll-fwdmkp-spinner",
  templateUrl: "../../../../shared/base-components/html/number-spinner.html",
  providers: [AMOUNT_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FwdRollFwdMarkupEditor
  extends FwdRollBaseEditor
  implements AgEditorComponent, AfterViewInit
{
  protected override updateModelValue() {
    this.modelData.updateForwardMarkup(this.data.value);
  }
}
